import { privateApi } from 'services';
import { ApiImporterConfiguration, ImporterConfig } from './types';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';

const publishImporterConfig = async (importerId: string): Promise<void> =>
    privateApi.post<void>(`job-group-importer-configs/${importerId}/publish`, {});

const republishImporterConfig = async (importerId: string): Promise<void> =>
    privateApi.post<void>(`job-group-importer-configs/${importerId}/republish`, {});

const deleteImporterConfig = async (importerId: string): Promise<void> =>
    privateApi.delete<void>(`job-group-importer-configs/${importerId}`, {});

export const ImporterConfigGateway = {
    publishImporterConfig,
    republishImporterConfig,
    deleteImporterConfig,
};

const cancelableFetchImporterConfigs = async (jobGroupId: string): Promise<ImporterConfig[]> =>
    privateApiWithRouteLeavingCancelation.get<ImporterConfig[]>(`job-group-importer-settings/${jobGroupId}/configs`);

const cancelableFetchImporterConfig = async (importerConfigId: string): Promise<ApiImporterConfiguration> =>
    privateApiWithRouteLeavingCancelation.get<ApiImporterConfiguration>(
        `job-group-importer-configs/${importerConfigId}/importer-config`,
    );

export const CancelableImporterConfigGateway = {
    cancelableFetchImporterConfigs,
    cancelableFetchImporterConfig,
};
